import { i18n } from "@lingui/core";
import React from 'react';
import SEO from '../components/shared/seo';
import { navigate } from 'gatsby';
import { useLingui } from '@lingui/react';
import useHasMounted from '../hooks/client-only-hook'; // IF user comes from "/" --> redirect to /en

var Redirect = function Redirect(props) {
  console.log({
    props: props
  });

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;
  var hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  navigate("/" + locale);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: i18n._(
    /*i18n*/
    i18n._("Home")),
    lang: locale
  }), /*#__PURE__*/React.createElement("p", null, i18n._(
  /*i18n*/
  i18n._("Redirecting to home.."))));
};

export default Redirect;